<template>
<div>
    <div class="az-content-header d-block d-md-flex">
        <div>
          <h2 class="az-content-title tx-24 mg-b-5 mg-b-lg-8">Service Centre</h2>
          <p class="mg-b-0 tx-13" v-loading= 'loading'>You have <strong>{{requests.length}}</strong> service requests.</p>
        </div>
        <div class='float-right'>
            <button @click="dialog = true" class='btn btn-outline-primary btn-block'><i class='el-icon-plus'></i> Create New Request</button>
        </div>
    </div><!-- az-content-header -->
    <div class="az-content-body" v-loading='loading'>
        <div class="az-content az-content-dashboard-fifteen">
            <el-empty style="margin-top:100px" description="You have no requests" v-show='is_empty'></el-empty>
            <div v-show='!is_empty' class="tickets-card card row" style='margin-left:5px' v-for="(request,index) in requests" :key="request.id">
                <div class="tickets-details col-lg-8 col-12" >
                    <div class="wrapper">
                        <h5>#{{request.id}} - {{isSample?'Sample Family Super Fund '+(index+1):request.smsfno__fund_name}}</h5>
                        <div class="badge" :class='request.status==="Pending"?"badge-primary":"badge-success"'>{{request.status}}</div>
                    </div>
                    <div class="wrapper text-muted d-none d-md-block tx-13">
                        <span>Created by {{isSample?'Sample User':request.createdby}}</span>
                        <span><i class="typcn icon typcn-time"></i>{{dateformats.getDateAndTime(request.createdon)}}</span>
                    </div>
                </div>
                <div class="tickets-details col-12 tx-13 mg-t-10">
                    <div class="tickets-card mg-b-5 pd-0">
                        <div><span class='tx-22' style='color:#cdd4e0'><i class='typcn typcn-mail'></i></span></div>
                        <p class='pd-10 mg-0'>{{request.servicereqecontent}}</p>
                    </div>
                    <div class="tickets-card mg-0 pd-0" v-show='request.response'>
                        <div><span class='tx-22' style='color:#cdd4e0'><i class='typcn typcn-arrow-back'></i></span></div>
                        <p class='pd-10 mg-0'>{{request.response}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <el-drawer
    title="New Request"
    :before-close="handleClose"
    :visible.sync="dialog"
    direction="rtl"
    custom-class="demo-drawer"
    ref="drawer"
    >
    <div class="demo-drawer__content mg-20">
        <el-form ref="form" :model="form" :rules="rules" size='small' class="demo-ruleForm">
        <el-form-item prop="fund">
            <el-select style='width:100%' v-model="form.fund" value-key="fund_code" placeholder="Select Fund">
                <el-option v-for="(fund,index) in funds" :key="fund.fund_code" :label="isSample?'Sample Family Super Fund '+(index+1):fund.fund_name" :value="fund"></el-option>
            </el-select>
        </el-form-item>
        <p v-show='form.fund.fund_code' class='tx-13 mg-5' style='color:#606266'><i class='el-icon-s-custom'></i> Fund Accountant: {{isSample?'Susan Sample':form.fund.fund_accountant}}</p>
        <el-form-item prop="desc">
            <el-input type="textarea" :rows='12' v-model="form.desc" placeholder="Your Message..."></el-input>
        </el-form-item>
        <el-form-item style='margin-bottom:0'>
            <el-checkbox-group v-model="form.urgent">
                <el-checkbox label="I require a response within 2 business hours"></el-checkbox>
            </el-checkbox-group>
        </el-form-item>
        <p class='tx-12' style='color:#606266'>(By default, service requests will be attended to within 1 business day)</p>
        </el-form>
        
        <div class="demo-drawer__footer mg-t-60">
        <el-button @click="cancelForm">Cancel</el-button>
        <el-button type="primary" @click="submitRequest" :loading="loading">{{ loading ? 'Sending...' : 'Send' }}</el-button>
        </div>
    </div>
    </el-drawer>
</div>
</template>
<script>
import dateformats from '../utils/dateformats'
export default {
    name: 'servicecenter',
    components: {

    },
    data(){
        return{
            brand_name:'',
            isSample:false,
            requests:[],
            dateformats:dateformats,
            dialog: false,
            funds:[],
            loading: true,
            form: {
                fund: {},
                desc: '',
                urgent: false
            },
            rules: {
                fund: [
                    { required: true, message: 'Please select a fund', trigger: 'blur' },
                ],
                desc: [
                    { required: true, message: 'Please fill in the request', trigger: 'blur' }
                ],
                urgent: [
                    { required: false }
                ]
            },
            formLabelWidth: '80px',
            timer: null,
            is_empty: true
        }
    },
    created(){
        this.getRequests()
    },
    mounted(){
        this.getSMSF()
    },
    methods:{
        getRequests: function(){
            const userdetail = JSON.parse(localStorage.getItem('userdetail'));
            this.isSample=userdetail['sample']
            let brand = localStorage.getItem('brand_code')
            this.brand_name = localStorage.getItem('brand_name')
            this.user_name = userdetail['firstname'] + ' ' + userdetail['lastname']
            this.email = userdetail['email'];
            this.$api.adviserdashboard_api.service_requests(brand).then(response =>{
                this.requests = response.data.funds_requests
                this.requests.length>0?this.is_empty=false:this.is_empty=true
                this.loading=false
            }) 
        },
        getSMSF: function(){
            const userdetail = JSON.parse(localStorage.getItem('userdetail'));
            let brand = userdetail['brand_list'][0][0];
            this.$api.adviserdashboard_api.smsfList().then(response =>{
                console.log('SMSF List:', response.data);
                console.log("Brand Code:", brand);
                const funds = response.data["funds"];
                this.funds = funds;
            }) 
        },
        submitRequest: function(done) {
            this.$refs.form.validate(valid => {
                if (!valid) {
                    this.$message.error("Please fill out all required fields.");
                    return;
                }
        
                this.loading = true;
        
                const payload = {
                    fund_code: this.form.fund.fund_code,
                    fund_name: this.form.fund.fund_name,
                    fund_accountant: this.form.fund.fund_name,
                    desc: this.form.desc,
                    urgent: this.form.urgent,
                    created_by: this.user_name,
                    email: this.email
                };
        
                this.$api.adviserdashboard_api.servicecenter(payload).then(response => {
                    console.log('Request sent successfully:', response.data);
                    this.form = { fund: '', desc: '', urgent: false };
                    this.$refs.form.resetFields();
                    this.getRequests();
                    this.dialog = false;
                    this.loading = false;
                }).catch(error => {
                    console.error('Error sending request:', error);
                    this.$message.error("Failed to send request.");
                    this.loading = false;
                });
            });
        },
        handleClose(done) {
            this.loading = false;
            this.dialog = false;
            if (this.loading) {
                return;
            }
        },
        cancelForm() {
        this.loading = false;
        this.dialog = false;
        clearTimeout(this.timer);
        }
    }
}
</script>
<style>
.el-checkbox {
    color: #606266;
    font-weight: 500;
}
.el-checkbox__label {
    display: inline-block;
    padding-left: 10px;
    line-height: 19px;
    font-size: 13px;
}
</style>
